import styled from "styled-components";
import {
	DESKTOP_SM_BP,
	FONT_WT_MEDIUM,
	FONT_WT_LIGHT,
	MOBILE_L_BP,
	COLOR_TEXT_PRIMARY_B2C,
	COLOR_WHITE,
	COLOR_DARK_GREEN_BUTTON,
	TABLET_M_BP,
} from "@website-builder/utilities-index";

export const BannerWrapper = styled.div`
	display: flex;
	margin-top: 104px;

	@media only screen and (max-width: ${TABLET_M_BP}px) {
		margin-top: 70px;
	}

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		flex-flow: wrap;
	}
`;

export const TextContainer = styled.div`
	width: 45%;
	margin: auto 20px auto 75px;
	@media only screen and (max-width: ${DESKTOP_SM_BP}px) {
		margin: auto 20px auto 35px;
	}

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		width: 100%;
		margin: 0;
		padding: 30px;
	}
`;

export const Heading = styled.div`
	font-size: 36px;
	max-width: 444px;
	font-weight: ${FONT_WT_MEDIUM};
	color: ${COLOR_TEXT_PRIMARY_B2C};
	margin-bottom: 40px;

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		font-size: 28px;
		margin-bottom: 40px;
		font-weight: ${FONT_WT_MEDIUM};
		font-size: 28px;
		line-height: 33px;
		text-align: center;

		color: ${COLOR_TEXT_PRIMARY_B2C};
	}
`;

export const SubHeading = styled.div`
	font-weight: ${FONT_WT_LIGHT};
	font-size: 16px;
	line-height: 24px;
	max-width: 523px;
	/* or 150% */

	color: ${COLOR_TEXT_PRIMARY_B2C};

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		margin-bottom: 25px;
		max-width: 284px;
		text-align: center;
	}
`;

export const ImageContainer = styled.div`
	height: 683px;
	width: 55%;
	background-color: ${(p) => (p.bg ? p.bg : "var(--primary-forest-600)")};
	.slick-slide p {
		color: ${(p) => (p.font ? p.font : COLOR_WHITE)};
	}
	display: flex;
	align-items: center;
	justify-content: center;

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		width: 100%;
		margin: 0;
		height: 530px;
		padding-bottom: 30px;
	}
`;

export const SliderContainer = styled.div`
	width: 300px;

	.slick-active .custom-dots {
		background-color: ${COLOR_DARK_GREEN_BUTTON};
	}

	.custom-dots {
		margin-top: 5px;
		background-color: ${COLOR_WHITE};
		width: 11px;
		height: 11px;
		border-radius: 50%;
	}
`;

export const ChangingTexts = styled.span`
	color: var(--primary-forest-600);

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		display: block;
	}
`;
